import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/HomePage";
import OurStoryPage from "@/pages/OurStoryPage";
import WhyPage from "@/pages/WhyPage";
import FranchisePage from "@/pages/FranchisePage";
import InvestmentPage from "@/pages/InvestmentPage";
import MenuLocationsPage from "@/pages/MenuLocationsPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";

function RequireAdmin({ children }) {
  if (typeof window !== "undefined" && !localStorage.getItem("pe_admin_token")) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function PublicShell({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Admin (no public layout) */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboardPage />
              </RequireAdmin>
            }
          />

          {/* Public site */}
          <Route path="/" element={<PublicShell><HomePage /></PublicShell>} />
          <Route path="/our-story" element={<PublicShell><OurStoryPage /></PublicShell>} />
          <Route path="/why-pizza-excellente" element={<PublicShell><WhyPage /></PublicShell>} />
          <Route path="/franchise-opportunity" element={<PublicShell><FranchisePage /></PublicShell>} />
          <Route path="/investment" element={<PublicShell><InvestmentPage /></PublicShell>} />
          <Route path="/menu-locations" element={<PublicShell><MenuLocationsPage /></PublicShell>} />
          <Route path="/contact" element={<PublicShell><ContactPage /></PublicShell>} />
          <Route path="*" element={<PublicShell><NotFoundPage /></PublicShell>} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          classNames: {
            toast: "rounded-none border border-pe-border bg-white text-pe-ink",
            title: "font-serif text-base",
          },
        }}
      />
    </div>
  );
}

export default App;
